module.exports = __webpack_public_path__ + "img/flight-deck-gal-1.99e164ee.jpg";